import { Heading, Subtitle } from './PageHeading.styles';
import type { PageHeadingProps } from './PageHeading.types';

export function PageHeading({ title, subtitle }: PageHeadingProps) {
  return (
    <Heading>
      {title}
      {subtitle && (
        <>
          {' '}
          <Subtitle>{subtitle}</Subtitle>
        </>
      )}
    </Heading>
  );
}
